import moment from "moment";
import { Base64 } from "js-base64";
import API from "@/api/common";
const TokenKey = "Trace_Token";
const OpenIdKey = "complaint_mobile_openId";
const TokenTime = "TokenTime";
const KEY_USER_CODE = "USER_CODE";
const REDIRECT_PATH = "REDIRECT_PATH";
const expireTime = 2 * 3600 * 1000;

let util = {
  isSign: async function() {
    if (await this.getToken()) {
      return true;
    }
    return false;
  },

  setTokenTime(key) {
    this.setItem(TokenTime, key);
  },

  setRedirectPath(path) {
    this.setItem(REDIRECT_PATH, path);
  },

  getRedirectPath() {
    const path = this.getItem(REDIRECT_PATH);
    if (!this.isNullOrUndefined(path)) {
      return JSON.parse(path);
    }
    return path;
  },

  setUser(data) {
    console.info("xxxx")
    console.info(data)
    this.setItem(KEY_USER_CODE, data);
  },
  getUser() {
    let user = this.getItem(KEY_USER_CODE);
    if (!this.isNullOrUndefined(user)) {
      return JSON.parse(user);
    }
    return user;
  },
  isNullOrUndefined(s) {
    if (s === null || s === undefined) {
      return true;
    }
    return false;
  },
  setToken(token) {
    this.setItem(TokenKey, token);
  },
  getToken() {
    var token = this.getItem(TokenKey);
    var time = this.getItem(TokenTime);
    if (token && new Date().getTime() <= parseInt(time) + expireTime) {
      return token;
    }
    return "";
  },

  removeToken() {
    return window.sessionStorage.removeItem(TokenKey);
  },
  getUserOpenId() {
    return window.localStorage.getItem(OpenIdKey);
  },
  setUserOpenId(openId) {
    return window.localStorage.setItem(OpenIdKey, openId);
  },
  removeUserOpenId() {
    return window.localStorage.removeItem(OpenIdKey);
  },
  decodeToken(token) {
    if (token && token.indexOf(".") > 0) {
      var arr = token.split(".");
      var user = Base64.decode(arr[1]);
      return user;
    }
  },
  getQueryString(name) {
    /* eslint-disable */
    return (
      decodeURIComponent(
        (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
          location.href
        ) || [, ""])[1].replace(/\+/g, "%20")
      ) || null
    );
    /* eslint-enable */
  },
  setDocumentTitle(title) {
    title = title || "PB Admin";
    window.document.title = title;
  },
  copy(target, dis) {
    if (target && dis) {
      for (var item in dis) {
        dis[item] = target[item];
      }
    }
  },
  monthFrm: function(params) {
    return moment(params).format("YYYY-MM");
  },
  dateFrm: function(params) {
    if (typeof params === "function") {
      return moment(params()).format("YYYY.MM.DD");
    } else {
      return moment(params).format("YYYY.MM.DD");
    }
  },
  timeFrm: function(params) {
    return moment(params).format("YYYY-MM-DD HH:mm:ss");
  },
  setItem(key, value) {
    if (window.localStorage) {
      window.localStorage.setItem(key, JSON.stringify(value));
    } else {
      //console.error("window.localStorage is not support!!");
    }
  },

  getItem(key) {
    if (window.localStorage) {
      return window.localStorage.getItem(key);
    } else {
      //console.error("window.localStorage is not support!!");
    }
  },

  removeItem(key) {
    if (window.localStorage) {
      return window.localStorage.removeItem(key);
    } else {
      //console.error("window.localStorage is not support!!");
    }
  },

  clear() {
    if (window.localStorage) {
      window.localStorage.clear();
    } else {
      //console.error("window.localStorage is not support!!");
    }
  },
  wxRedirect() {
    // let href = location.href;
    const href = "http://wx.dafaland.com:85/mobile/news";
    this.setRedirectPath(href);
    const appId = process.env.VUE_APP_CORPID;
    const redirect = process.env.VUE_APP_WEIXIN_SHARE_URL.replace(
      "#APPID",
      appId
    )
      .replace("#URL", href)
      .replace("#STATE", appId);
    console.log(redirect);
    window.location.href = redirect;
  },

  getUserByAppId(params) {
    return new Promise(resolve => {
      API.findUserCode(params.code, params.agent, params.appId).then(res => {
        resolve(res);
      });
    });
  }
};
export default util;
